import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PetitionCommentPagePrefetchedDataProps } from 'src/app/pages/petition/comment/pageContext';
import { PetitionCommentPageContextProvider, prefetchPageContext } from 'src/app/pages/petition/comment/pageContext';
import type { PetitionTabProps } from 'src/app/pages/petition/shared/tabTypes';

import { Layout } from '../layout';

import { PetitionCommentErrorHandler } from './ErrorHandler';

export const PetitionComment = withPrefetchedData(
	function PetitionComment({ prefetchedData }: PetitionCommentPagePrefetchedDataProps & PetitionTabProps): JSX.Element {
		const { slug, id } = useKnownAvailableParams<{ slug: string; id: string }>();

		return (
			<PetitionCommentPageContextProvider
				commentId={id}
				petitionSlug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PetitionCommentErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</PetitionCommentPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context.params.id!, context),
	},
);
